import { motion } from 'framer-motion';

export function TrustBar() {
  const indicators = [
    { icon: 'ri-award-line', value: '40+', label: 'Years of Experience' },
    { icon: 'ri-building-line', value: '900+', label: 'Locations Nationwide' },
    { icon: 'ri-star-fill', value: '5-Star', label: 'Google Rated' },
    { icon: 'ri-shield-check-line', value: 'Licensed', label: '& Insured' },
    { icon: 'ri-timer-flash-line', value: 'Same-Week', label: 'Turnaround Available' },
    { icon: 'ri-medal-line', value: 'Free', label: 'Design Consultation' },
  ];

  return (
    <section className="bg-gray-900 py-5 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-4">
          {indicators.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.07 }}
              className="flex items-center space-x-3"
            >
              <div className="w-9 h-9 bg-teal-500/15 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-teal-400 text-lg`}></i>
              </div>
              <div>
                <span className="text-white font-bold text-sm">{item.value}</span>
                <span className="text-gray-400 text-xs ml-1">{item.label}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
